import type { ConsolidationChangeStatus } from "@/models/legislation/metadata/ConsolidationMetadata";
import type { DeletedContainerChange } from "@/models/consolidation";

/**
 * Shared empty values for DocumentRenderer's consolidation props.
 *
 * They must keep one identity across renders: the renderer memoises its
 * whole-document sanitize and parse on these props, and a fresh `new Set()`
 * per render re-ran DOMPurify over the entire document on every click and
 * hover (~0.9 s on a 16 MB workspace PDF, LAR-487).
 */
export const EMPTY_CONTAINER_IDS: ReadonlySet<string> = new Set<string>();

export const EMPTY_CONTAINER_GROUP_KEYS: ReadonlyMap<string, string> = new Map<
  string,
  string
>();

export const EMPTY_CONTAINER_STATUS_BY_ID: ReadonlyMap<
  string,
  ConsolidationChangeStatus
> = new Map<string, ConsolidationChangeStatus>();

export const EMPTY_DELETED_CONTAINER_CHANGES: readonly DeletedContainerChange[] =
  Object.freeze([]);
